<template>
  <div>
    <v-col class="px-0" v-if="wallets.length > 0">
      <v-row>
        <v-col cols="6">
          <v-select v-model="filter.period" :items="periods" label="Período" item-text="value" return-object @change="search(filter)">
          </v-select>
        </v-col>
        <v-col cols="6" v-show="advancedWalletOptions === 'true' && showWallets === 'true'">
          <v-select
              v-model="filter.wallet"
              :items="wallets"
              item-text="name"
              label="Carteira"
              required
              return-object
              @change="search(filter)"
          ></v-select>
        </v-col>
      </v-row>
      <v-layout v-resize="onResize">
        <v-col class="px-0">
          <v-data-table
              :hide-default-header="isMobile"
              :headers="headers"
              :items="rows"
              :loading="loading"
              :items-per-page="50"
              locale="pt-BR"
              :hide-default-footer="rows.length === 0 || rows.length < 10"
          >
            <template v-slot:item.type="{ item }">
              <template v-if="item.type === 17">
                Regularização do veículo {{ item.plate }}
              </template>
              <template v-else-if="item.type === 6">
                Estacionamento {{ item.plate }}
              </template>
              <template v-else>
                {{ item.type_name }}
              </template>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | timeStampToHuman }}
            </template>
            <template v-slot:item.amount="{ item }">
              R$ {{ item.amount | integerToMoney | integerToMoney2 }}
            </template>
            <template slot="no-data">
              Nenhum dado encontrado.
            </template>
            <template slot="loading">
              Carregando
            </template>
          </v-data-table>
        </v-col>
      </v-layout>
    </v-col>
    <div class="message-data text-center" v-show="wallets.length === 0 && loading === false">
      <i class="far fa-bell"></i>
      <span>Você não possui nenhuma carteira cadastrada.</span>
    </div>
  </div>
</template>

<script>
import '../filters';
import axios from 'axios';
import moment from 'moment';

export default {
  name: "WalletsHistory",
  data: function () {
    return {
      isMobile: false,
      filter: {
        wallet: {
          name: ''
        },
        period: null
      },
      periods: [
        {label: 0, value: 'Todo o período'},
        {label: 1, value: 'Hoje'},
        {label: 2, value: 'Os últimos 7 dias'},
        {label: 3, value: 'Esse mês'},
        {label: 4, value: 'Mês anterior'},
        {label: 5, value: 'Esse ano'}
      ],
      wallets: [],
      loading: false,
      headers: [
        {text: 'Operação', sortable: false, filter: false, value: 'type'},
        {text: 'Data', sortable: false, filter: false, value: 'created_at'},
        {text: 'Forma de Pagamento', sortable: false, filter: false, value: 'payment_form_name'},
        {text: 'Valor', sortable: false, filter: false, value: 'amount'},
      ],
      rows: []
    }
  },
  mounted() {
    this.loading = true;
    axios.get('/api/users/driver/me/wallet').then(res => {
      this.wallets = res.data.data;
      this.filter.wallet = this.wallets[0];
      this.filter.period = this.periods[0];
      this.search(this.filter);
      this.loading = false;
    });
  },
  methods: {
    paymentForms(value) {
      switch (value) {
        case 1:
          return "Dinheiro";
        case 2:
          return "Cartão de crédito";
        case 3:
          return "Cartão de débito";
        case 4:
          return "Crédito da carteira";
        case 5:
          return "Boleto";
        case 6:
          return "DAM";
        case 7:
          return "Google Play";
        case 8:
          return "Apple Pay";
        case 9:
          return "Transferência";
        case 10:
          return "PicPay";
        case 11:
          return "Pix";
        case "bonus":
          return "Bônus da carteira";
        default:
          return "---";
      }
    },
    onResize: function () {
      this.isMobile = window.innerWidth < 769;
    },
    search: function (filter) {
      this.rows = [];
      const obj = {};
      if (filter.wallet.id) {
        obj.wallet = filter.wallet.id;
      } else {
        return true;
      }
      switch (filter.period.label) {
        case 1:
          obj.created_at_begin = moment().format('YYYY-MM-DD 00:00:00');
          obj.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 2:
          obj.created_at_begin = moment().subtract('7', 'days').format('YYYY-MM-DD 00:00:00');
          obj.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          obj.created_at_begin = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
          obj.created_at_end = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 4:
          obj.created_at_begin = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
          obj.created_at_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 5:
          obj.created_at_begin = moment().startOf('year').format('YYYY-MM-DD 00:00:00');
          obj.created_at_end = moment().endOf('year').format('YYYY-MM-DD 23:59:59');
          break;
      }
      this.loading = true;
      axios.get('/api/users/driver/me/app/transaction', {params: obj}).then(res => {
        this.rows = res.data.data;
        this.loading = false;
      });
    }
  },
  computed: {
    advancedWalletOptions: function () {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    }
  }
}
</script>

<style scoped>
th, td.v-data-table__mobile-row {
  padding: 0 !important;
}
</style>
